import React, { useState, useEffect } from 'react';
import { 
  ArrowRight, Compass, Heart, Map, Sparkles, Search, ChevronLeft, 
  Star, Trophy, Zap, Globe, Camera, Coffee, LayoutGrid, ChevronRight,
} from 'lucide-react';

import { getDaysBetweenDatesUTC, getRandomHexColor, ellipsify } from '../../../../../helpers/general';

const Type4TrendsHomePage = (props) => {

    const { 
      setSelectedItinerary,
      highlightedItineraries,
      pageTheme,
      PAGI_LIMIT,
      totalItems,
      setpagiCurrentPage,
      pagiCurrentPage,
    } = props;

    const {
      packageTrendsPageBackground,
      packageTrendsPageCardBackground,
      packageTrendsPagePrimaryColor,
      packageTrendsPageSecondColor,
      packageTrendsPageThirdColor,
      packageTrendsPageFourthColor,
      packageTrendsPageLabels,
    } = pageTheme;

    const {
      fourPartStatsSection,
      listSection,
    } = packageTrendsPageLabels;

    /*const HERO_ITEMS = [
      {
        image: "https://images.unsplash.com/photo-1523059623039-a9ed027e7fad?auto=format&fit=crop&q=80&w=1920",
        tag: "Experience West Africa",
        title: "Your Journey to Ghana Starts Here",
        description: "Curated bespoke itineraries designed to immerse you in the vibrant culture, rich history, and breathtaking landscapes of the Gold Coast."
      },
      {
        image: "https://images.unsplash.com/photo-1590603740183-980e7f6920eb?auto=format&fit=crop&q=80&w=1920",
        tag: "Cultural Immersion",
        title: "Discover the Heart of Asante Culture",
        description: "From the bustling markets of Kumasi to the serene palaces, witness the living history of one of Africa's most storied kingdoms."
      },
      {
        image: "https://images.unsplash.com/photo-1516426122078-c23e76319801?auto=format&fit=crop&q=80&w=1920",
        tag: "Wildlife Adventure",
        title: "Safari in the Untamed North",
        description: "Experience the majestic beauty of Mole National Park, where elephants roam free across the vast savannah landscapes."
      }
    ];*/

    const [HERO_ITEMS, SET_HERO_ITEMS] = useState([]);
    const [currentSlide, setCurrentSlide] = useState(0);

    useEffect(() => {
      SET_HERO_ITEMS(highlightedItineraries);
      if(highlightedItineraries?.length>0){
        const timer = setInterval(() => {
          setCurrentSlide((prev) => (prev + 1) % highlightedItineraries.length);
        }, 6000);
        return () => clearInterval(timer);
      }
    }, [ highlightedItineraries ]);

    const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % HERO_ITEMS.length);
    const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + HERO_ITEMS.length) % HERO_ITEMS.length);


    const styles = {
        hero: {
            /*display: "none",*/
            background: (packageTrendsPagePrimaryColor || 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)'),
            padding: '6rem 1rem',
            textAlign: 'center',
            color: '#ffffff',
            position: 'relative',
            //overflow: 'hidden',
        },
        section: {
            padding: '5rem 1rem',
            maxWidth: '1200px',
            margin: '0 auto',
        },
        heading: {
            fontSize: '2.5rem',
            fontWeight: 900,
            color: '#0f172a',
            marginBottom: '1rem',
            textAlign: 'center',
            letterSpacing: '-0.025em',
        },
        subHeading: {
            fontSize: '1.125rem',
            color: '#64748b',
            textAlign: 'center',
            marginBottom: '3.5rem',
            maxWidth: '600px',
            margin: '0 auto 3.5rem auto',
        },
        card: {
            backgroundColor: (packageTrendsPageCardBackground || '#ffffff'),
            borderRadius: '1.5rem',
            overflow: 'hidden',
            boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.04)',
            border: '1px solid #f1f5f9',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        },
        badge: {
            position: 'absolute',
            top: '1rem',
            left: '1rem',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            padding: '0.4rem 0.8rem',
            borderRadius: '999px',
            fontSize: '0.75rem',
            fontWeight: 800,
            color: (packageTrendsPagePrimaryColor || '#4f46e5'),
            display: 'flex',
            alignItems: 'center',
            gap: '0.4rem',
            backdropFilter: 'blur(4px)',
        },
        inputWrapper: {
          display: 'flex',
          alignItems: 'center',
          gap: '0.75rem',
          padding: '0.75rem 1rem',
          backgroundColor: 'white',
          borderRadius: '0.85rem',
          border: '1px solid #e2e8f0',
          transition: 'all 0.2s ease',
        }
    };

    const all_pages = [1];
    let i=1;
    while(true){
        i+=PAGI_LIMIT;
        if(i>=totalItems){
            break
        }
        all_pages.push(i);
    }

    /* 
    packageTrendsPageLabels: {
        listSection: {
          title: "",
          description: "",
        },
        threePartPromiseSection: {
          type4: {
            show: true,
            title: "",
            description: "",
            partOne: {
              icon: "",
              title: "",
              description: "",
            },
            partTwo: {
              icon: "",
              title: "",
              description: "",
            },
            partThree: {
              icon: "",
              title: "",
              description: "",
            },
            partFour: {
              icon: "",
              title: "",
              description: "",
            }
          },
          type5: {
            title: "",
            description: "",
            partOne: {
              icon: "",
              title: "",
              description: "",
            },
            partTwo: {
              icon: "",
              title: "",
              description: "",
            },
            partThree: {
              icon: "",
              title: "",
              description: "",
            },
            partFour: {
              icon: "",
              title: "",
              description: "",
            }
          }
        },
        callToActionSection: {
          type4: {
            show: true,
            title: "",
            description: "",
            actionButtonText: "",
            
          }
        },
      },
    */

    return  (
    <div style={{backgroundColor: packageTrendsPageBackground, position: "relative"}} className="bg-white">
      
      {/* Hero Section */}
      <section className='h-[70vh] flex items-center justify-center' style={styles.hero}>
        <img
            src={HERO_ITEMS[currentSlide]?.image || "https://images.unsplash.com/photo-1523059623039-a9ed027e7fad?auto=format&fit=crop&q=80&w=1920"}
            alt={HERO_ITEMS[currentSlide]?.purpose || "Trending Itineraries"}
            className="absolute inset-0 w-full h-full object-cover -opacity-60"
            referrerPolicy="no-referrer"
          />
        <div className="max-w-4xl mx-auto relative w-full -h-full z-10">
          <div className='-rounded-2xl -border -border-white/20 -backdrop-blur-md' style={{/*backgroundColor: "rgba(0,0,0,0.5)", padding: 20*/}}>
            {/*<div style={{backgroundColor: "rgba(0,0,0,0.5)"}}
              className="inline-flex items-center gap-2 bg-white/10 border border-white/20 px-4 py-2 rounded-full mb-8 backdrop-blur-md">
              <Sparkles style={{ width: "16px", height: "16px" }} className="text-indigo-500" />
              <span dangerouslySetInnerHTML={{ __html: ("Recently Highlighted") }}
                className="text-xs font-black uppercase tracking-widest text-white-500"></span>
            </div>*/}
            <h1 style={{color: packageTrendsPageSecondColor, textShadow: "1px 1px 0 #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000"}} className="text-2xl md:text-4xl font-black mb-6 leading-tight">
                  {HERO_ITEMS[currentSlide]?.purpose || "Trending Itineraries"} <br /> <span>
                    {
                      HERO_ITEMS[currentSlide]?.destination &&
                      <i style={{marginRight: 10, color: packageTrendsPagePrimaryColor}} className="fa-solid fa-map-marker-alt"></i>
                    }
                  {HERO_ITEMS[currentSlide]?.destination}</span>
            </h1>
            {/*<p dangerouslySetInnerHTML={{ __html: (
                (ellipsify((HERO_ITEMS[currentSlide]?.description || ""), 120)) ||
                "Hand-picked itineraries designed by experts to take you beyond the guidebook and into the heart of the world's most incredible places."
              )}}
                style={{color: (packageTrendsPageSecondColor/*+"E6"/), textShadow: "1px 1px 0 #000, -1px -1px 0 #000, 1px -1px 0 #000, -1px 1px 0 #000"}} className="text-lg md:text-xl text-indigo-100 mb-10 max-w-2xl mx-auto font-medium leading-relaxed">
            </p>*/}
            {
              highlightedItineraries?.[0] &&
              <div className="flex flex-col sm:flex-row items-center justify-center gap-1">
                <button onClick={()=>setSelectedItinerary(HERO_ITEMS[currentSlide])}
                  style={{border: "none", color: packageTrendsPagePrimaryColor, background: packageTrendsPageSecondColor}}
                  className="bg-white text-indigo-600 px-10 py-2 -rounded-2xl -font-black shadow-xl shadow-indigo-950/20 hover:scale-105 transition-transform flex items-center gap-3"
                >
                  <span className='text-sm'
                    dangerouslySetInnerHTML={{ __html: ("View Itinerary") }}></span><ArrowRight  style={{ width: "16px", height: "16px" }} />
                </button>
                <button onClick={() => document.getElementById('all_itineraries_section')?.scrollIntoView({ behavior: 'smooth' })}
                  style={{border: "none", backgroundColor: (packageTrendsPagePrimaryColor)}}
                  className="bg-indigo-500 text-white border-2 border-white/30 px-10 py-2 -rounded-2xl -font-black hover:bg-white/10 transition-colors flex items-center gap-3"
                >
                  <LayoutGrid style={{ width: "16px", height: "16px" }} /><span className='text-sm'
                    dangerouslySetInnerHTML={{ __html: ("All Itineraries") }}></span>
                </button>
              </div>
            }
          </div>
        </div>
        {/* Background Decorative Elements 
        <div className="absolute top-[-10%] left-[-5%] w-64 h-64 bg-white/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-[-20%] right-[-10%] w-96 h-96 bg-indigo-400/20 rounded-full blur-3xl"></div>*/}
        {/* Carousel Controls */}
        <div className="absolute bottom-20 left-0 right-0 z-40 flex items-center justify-center gap-12">
          <div className="flex gap-4">
            {HERO_ITEMS.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`h-1.5 rounded-full transition-all duration-500 ${
                  index === currentSlide ? "w-12 bg-["+packageTrendsPagePrimaryColor+"] shadow-lg shadow-["+packageTrendsPagePrimaryColor+"] -500/50" : "w-3 bg-white/30 hover:bg-white/50"
                }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>

        <button
          onClick={prevSlide}
          className="absolute left-8 top-1/2 -translate-y-1/2 z-40 p-4 rounded-full bg-white/5 backdrop-blur-md border border-white/10 text-white hover:bg-white/20 transition-all hidden lg:flex active:scale-90"
          aria-label="Previous slide"
        >
          <ChevronLeft className="w-6 h-6" />
        </button>
        <button
          onClick={nextSlide}
          className="absolute right-8 top-1/2 -translate-y-1/2 z-40 p-4 rounded-full bg-white/5 backdrop-blur-md border border-white/10 text-white hover:bg-white/20 transition-all hidden lg:flex active:scale-90"
          aria-label="Next slide"
        >
          <ChevronRight className="w-6 h-6" />
        </button>
      </section>

      {/* Stats Section */}
      {
        packageTrendsPageLabels?.fourPartStatsSection?.show &&
        <div style={{/*display: "none"*/}} className="max-w-7xl mx-auto px-4 -mt-12 relative z-20">
          <div style={{backgroundColor: packageTrendsPageCardBackground}} className="bg-white rounded-3xl shadow-2xl shadow-slate-200/50 border border-slate-100 p-8 grid grid-cols-2 md:grid-cols-4 gap-8">
            <div className="text-center">
              <p dangerouslySetInnerHTML={{ __html: (fourPartStatsSection?.firstValue || "500+") }}
                className="text-3xl font-black text-slate-900 mb-1"></p>
              <p dangerouslySetInnerHTML={{ __html: (fourPartStatsSection?.firstDescription || "Destinations") }}
                className="text-xs font-bold text-slate-400 uppercase tracking-widest"></p>
            </div>
            <div className="text-center border-l border-slate-100">
              <p dangerouslySetInnerHTML={{ __html: (fourPartStatsSection?.secondValue || "12k+") }}
                className="text-3xl font-black text-slate-900 mb-1"></p>
              <p dangerouslySetInnerHTML={{ __html: (fourPartStatsSection?.secondDescription || "Happy Travelers") }}
                className="text-xs font-bold text-slate-400 uppercase tracking-widest"></p>
            </div>
            <div className="text-center border-l border-slate-100">
              <p dangerouslySetInnerHTML={{ __html: (fourPartStatsSection?.thirdValue || "4.9/5") }}
                className="text-3xl font-black text-slate-900 mb-1"></p>
              <p dangerouslySetInnerHTML={{ __html: (fourPartStatsSection?.thirdDescription || "Trust Score") }}
                className="text-xs font-bold text-slate-400 uppercase tracking-widest"></p>
            </div>
            <div className="text-center border-l border-slate-100">
              <p dangerouslySetInnerHTML={{ __html: (fourPartStatsSection?.fourthValue || "24/7") }}
                className="text-3xl font-black text-slate-900 mb-1"></p>
              <p dangerouslySetInnerHTML={{ __html: (fourPartStatsSection?.fourthDescription || "Support") }}
                className="text-xs font-bold text-slate-400 uppercase tracking-widest"></p>
            </div>
          </div>
        </div>
      }

      {/* Trending Itineraries */}
      <section id="all_itineraries_section" style={{...styles.section, paddingTop: 40, paddingBottom: 20}}>
        <h2 dangerouslySetInnerHTML={{ __html: (listSection?.title || "Trending This Season") }}
              style={{...styles.heading}}></h2>
        <p dangerouslySetInnerHTML={{ __html: (
          listSection?.description ||
          "The most loved trips by our community, refreshed every week with exclusive experiences.") }}
              style={{...styles.subHeading}}></p>
        <div style={{/*padding: "0 10px", */paddingBottom: 20, display: "flex", justifyContent: "space-between", alignItems: "center"}}>
            {/*<div>
                <p style={{color: "grey", fontSize: 12}}>
                    <span style={{color: "blue", margin: 5, fontSize: 13}}>{totalItems}</span> 
                    item(s) found
                </p>
            </div>*/}
            <div style={styles.inputWrapper} className="hover:border-indigo-200 hover:bg-white focus-within:border-indigo-400 focus-within:bg-white">
                <Search style={{ width: "24px", height: "24px" }} className="text-slate-400" />
                <input id="__"
                    type="text"
                    placeholder="Enter City, Country, or Title"
                    className="bg-transparent -border-none -outline-none text-sm -font-bold text-slate-900 w-full"
                />
            </div>
            <div>
                <select onInput={e=>setpagiCurrentPage(e.target.value)}
                    value={pagiCurrentPage}
                    style={{/*backgroundColor: pageTheme?.actionButtonsBg, color: pageTheme?.actionButtonsTxtColor,*/ background: "none", color: "black"}}
                    className="select-input-paginator"
                >
                    {
                        all_pages?.map((each, i)=>{
                            return <option style={{backgroundColor: pageTheme?.actionButtonsBg, color: pageTheme?.actionButtonsTxtColor}}
                                value={each}
                            >{each} - {(each+PAGI_LIMIT)}</option>
                                
                        })  
                    }
                </select>
            </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-2">
          {highlightedItineraries.map((trip, idx) => {
            let _duration = getDaysBetweenDatesUTC(trip.start_date, trip.end_date);
            if(isNaN(_duration))
              _duration = ""
            else
              _duration = (_duration>1 ? (_duration+" days") : (_duration+"day"));

            return <div 
              key={idx} 
              style={styles.card} 
              className="group cursor-pointer hover:shadow-2xl hover:shadow-indigo-100 transition-all hover:translate-y-[-4px]"
            >
              <div style={{background: (trip.image ? "none" : getRandomHexColor())}} className="relative h-64 overflow-hidden">
                <img src={trip.image} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500" />
                <div style={styles.badge}>
                  <Star style={{ width: "16px", height: "16px" }} fill="currentColor" /> {(trip.short_tag || "No Tag")}
                </div>
              </div>
              <div className="p-6">
                <div style={{color: packageTrendsPagePrimaryColor}} className="flex items-center gap-2 text-[10px] font-black text-indigo-600 uppercase tracking-widest mb-3">
                  <Map style={{ width: "16px", height: "16px" }} /> {trip.destination}
                </div>
                <h3 style={{color: packageTrendsPageThirdColor}} className="text-xl font-black text-slate-900 mb-2">{trip.purpose}</h3>
                <p style={{color: (packageTrendsPageThirdColor+"80")}}
                  className="text-gray-500 text-sm leading-relaxed mb-6 flex-grow line-clamp-3">
                  {trip.description}
                </p>
                <div className="flex items-center justify-between mt-0 pt-2 border-t border-slate-50">
                  <span className="text-sm font-bold text-slate-400">{_duration}</span>
                  <div className="text-right">
                    <span className="block text-[10px] font-black text-slate-300 uppercase">From</span>
                    <span style={{color: packageTrendsPagePrimaryColor}} className="text-lg font-black text-indigo-600">{(trip.price || "0.00")}</span>
                  </div>
                </div>
                <div onClick={()=>setSelectedItinerary(trip)} style={{color: packageTrendsPagePrimaryColor}} className="mt-4 flex items-center justify-center gap-2 text-indigo-600 font-black text-[10px] uppercase tracking-widest -opacity-50 -group-hover:opacity-100 transition-opacity">
                  <span style={{fontSize: 13}} dangerouslySetInnerHTML={{ __html: ("View Full Journey ") }}></span><ArrowRight style={{ width: "16px", height: "16px" }} />
                </div>
              </div>
            </div>
          })}
        </div>
        {
          (Array.isArray(highlightedItineraries) && highlightedItineraries?.length < 1 ) && <div style={{padding: 20, backgroundColor: "rgba(255,0,0,0.1)", color: "red", textAlign: "center"}}>
            There are no itineraries at this moment...
          </div>
        }
      </section>

      {/* Value Props */}
      {
        /*threePartPromiseSection?.type4?.partOne?.icon: "",
        threePartPromiseSection?.type4?.partTwo?.icon: "",
        threePartPromiseSection?.type4?.partThree?.icon: "",*/
      }
      {
        packageTrendsPageLabels?.threePartPromiseSection?.type4?.show &&
        <section style={{backgroundColor: packageTrendsPageCardBackground}} className="bg-slate-50 py-20">
          <div style={styles.section}>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
              <div>
                <h2 dangerouslySetInnerHTML={{ __html: (packageTrendsPageLabels?.threePartPromiseSection?.type4?.title || "Travel Smarter, <br/> Explore Further") }} className="text-4xl font-black text-slate-900 mb-6 leading-tight text-left">
                </h2>
                <div className="space-y-8 mt-10">
                  <div className="flex gap-5">
                    <div style={{backgroundColor: packageTrendsPagePrimaryColor}} className="w-14 h-14 shrink-0 bg-indigo-600 text-white rounded-2xl flex items-center justify-center -shadow-lg -shadow-indigo-200">
                      <Trophy style={{ width: "16px", height: "16px" }} />
                    </div>
                    <div>
                      <h4 dangerouslySetInnerHTML={{ __html: (packageTrendsPageLabels?.threePartPromiseSection?.type4?.partOne?.title || "Expertly Curated") }} className="text-lg font-black text-slate-900 mb-1"></h4>
                      <p dangerouslySetInnerHTML={{ __html: (
                        packageTrendsPageLabels?.threePartPromiseSection?.type4?.partOne?.description ||
                        "Every hotel and activity is personally vetted by our global team of travel writers and scouts.") }}
                        className="text-sm text-slate-500 font-medium leading-relaxed"></p>
                    </div>
                  </div>
                  <div className="flex gap-5">
                    <div style={{backgroundColor: packageTrendsPageBackground}} className="w-14 h-14 shrink-0 bg-white text-indigo-600 rounded-2xl flex items-center justify-center border border-indigo-100 shadow-sm">
                      <Zap style={{color: packageTrendsPagePrimaryColor, width: "16px", height: "16px" }} />
                    </div>
                    <div>
                      <h4 dangerouslySetInnerHTML={{ __html: (packageTrendsPageLabels?.threePartPromiseSection?.type4?.partTwo?.title || "Instant Customization") }}
                        className="text-lg font-black text-slate-900 mb-1"></h4>
                      <p dangerouslySetInnerHTML={{ __html: (
                        packageTrendsPageLabels?.threePartPromiseSection?.type4?.partTwo?.description ||
                        "Switch hotels, change dates, or add activities in real-time. We make planning as easy as clicking a button.") }}
                        className="text-sm text-slate-500 font-medium leading-relaxed"></p>
                    </div>
                  </div>
                  <div className="flex gap-5">
                    <div style={{backgroundColor: packageTrendsPageBackground}} className="w-14 h-14 shrink-0 bg-white text-indigo-600 rounded-2xl flex items-center justify-center border border-indigo-100 shadow-sm">
                      <Globe style={{color: packageTrendsPagePrimaryColor, width: "16px", height: "16px" }} />
                    </div>
                    <div>
                      <h4 dangerouslySetInnerHTML={{ __html: (packageTrendsPageLabels?.threePartPromiseSection?.type4?.partThree?.title || "Best-In-Class Prices") }}
                        className="text-lg font-black text-slate-900 mb-1"></h4>
                      <p dangerouslySetInnerHTML={{ __html: (
                        packageTrendsPageLabels?.threePartPromiseSection?.type4?.partThree?.description ||
                        "Our relationships with airlines and hotels mean you get access to rates you won't find anywhere else.") }}
                        className="text-sm text-slate-500 font-medium leading-relaxed"></p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="relative">
                <div style={{backgroundColor: (packageTrendsPagePrimaryColor+"40")}} className="bg-indigo-600 rounded-3xl aspect-[4/5] relative overflow-hidden shadow-2xl">
                  <img src="https://images.unsplash.com/photo-1527631746610-bca00a040d60?auto=format&fit=crop&w=800&q=80" className="w-full h-full object-cover opacity-80" alt="" />
                  <div className="absolute inset-0 bg-gradient-to-t from-indigo-900/80 to-transparent"></div>
                  <div className="absolute bottom-8 left-8 right-8">
                      <div className="flex items-center gap-3 mb-4">
                        <div className="w-10 h-10 rounded-full bg-white/20 backdrop-blur-md flex items-center justify-center">
                            <Coffee style={{color: packageTrendsPageSecondColor, width: "16px", height: "16px" }} className="text-white" />
                        </div>
                        <p dangerouslySetInnerHTML={{ __html: ("Morning in Santorini") }}
                            style={{color: packageTrendsPageSecondColor}} className="text-white font-bold text-sm"></p>
                      </div>
                      <div className="flex gap-2">
                        <div style={{backgroundColor: packageTrendsPageSecondColor}} className="h-1 flex-1 bg-white rounded-full"></div>
                        <div style={{backgroundColor: (packageTrendsPageSecondColor+"40")}} className="h-1 flex-1 bg-white/30 rounded-full"></div>
                        <div style={{backgroundColor: (packageTrendsPageSecondColor+"40")}} className="h-1 flex-1 bg-white/30 rounded-full"></div>
                      </div>
                  </div>
                </div>
                <div style={{backgroundColor: packageTrendsPageBackground}} className="absolute -top-10 -right-10 w-40 h-40 bg-white rounded-3xl shadow-xl p-6 hidden lg:flex flex-col justify-between border border-slate-100">
                  <Heart className="text-red-500 self-end" fill="currentColor"  style={{ width: "16px", height: "16px" }} />
                  <div>
                      <p dangerouslySetInnerHTML={{ __html: ("Saved by") }}
                          className="text-[10px] font-black text-slate-400 uppercase tracking-widest"></p>
                      <p dangerouslySetInnerHTML={{ __html: ("2.4k+") }}
                          className="text-xl font-black text-slate-900"></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      }

      {/* Call to Action Footer */}
      {
        packageTrendsPageLabels?.callToActionSection?.type4?.show &&
        <section style={{backgroundColor: packageTrendsPageBackground/*, display: "none"*/}} className="bg-slate-900 py-24 relative overflow-hidden">
          <div className="max-w-4xl mx-auto px-4 text-center relative z-10">
            <h2 dangerouslySetInnerHTML={{ __html: ("Ready to write your next chapter?") }}
                style={{color: packageTrendsPagePrimaryColor}} className="text-4xl md:text-5xl font-black text-white mb-8"></h2>
            <p dangerouslySetInnerHTML={{ __html: ("Join 50,000+ travelers who get our best deals and hidden itineraries every week.") }}
                className="text-slate-400 text-lg mb-12 font-medium"></p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <button dangerouslySetInnerHTML={{ __html: ("Search By Location") }}
                  style={{border: "none", backgroundColor: packageTrendsPagePrimaryColor, color: packageTrendsPageSecondColor}}
                className="w-full sm:w-auto bg-indigo-600 text-white px-12 py-5 rounded-2xl font-black text-lg hover:bg-indigo-700 hover:scale-105 transition-all shadow-xl shadow-indigo-950/40"
              >
              </button>
              <div className="flex items-center gap-3 ml-4">
                <div className="flex -space-x-3">
                  {[1, 2, 3, 4].map(i => (
                    <img key={i} src={`https://api.dicebear.com/7.x/avataaars/svg?seed=${i + 20}`} className="w-10 h-10 rounded-full border-2 border-slate-200" alt="" />
                  ))}
                </div>
                <span dangerouslySetInnerHTML={{ __html: ("+ 12k Others") }}
                  style={{color: packageTrendsPagePrimaryColor}} className="text-sm font-bold text-slate-400"></span>
              </div>
            </div>
          </div>
          <div className="absolute top-0 left-0 w-full h-full opacity-5 pointer-events-none">
            <Compass  style={{ width: "16px", height: "16px" }} className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] text-white" />
          </div>
        </section>
      }
    </div>
  );

}

export default Type4TrendsHomePage;